import axios from 'axios';
import { Message } from 'element-ui';
import { redirectToLogin, recheckSession } from './auth';

// Session Cookie 方案：请求带 Cookie，不设置 Authorization
const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
  withCredentials: true,
});

/** 后台请求（轮询/静默刷新）标记：失败不弹提示、401 不整页跳登录，避免打断用户手头的活 */
function isSilent(config) {
  return !!(config && config.silent);
}

let sessionRecheck = null;

/**
 * 401 兜底：并发请求共用一次 /auth/session 复核，确认会话真的失效才跳登录页。
 * 单个请求拿到 401 就整页跳转，会把用户没保存的选图/表单一起冲掉。
 */
function confirmSessionLost() {
  if (!sessionRecheck) {
    sessionRecheck = recheckSession()
      .then(user => {
        if (!user) redirectToLogin();
        return !user;
      })
      .catch(() => false)
      .then(lost => {
        sessionRecheck = null;
        return lost;
      });
  }
  return sessionRecheck;
}

// 响应拦截 — 统一处理业务错误码；401 先复核会话，确认失效才跳统一登录页
request.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 0) {
      if (!isSilent(response.config)) Message.error(res.message || '请求失败');
      return Promise.reject(new Error(res.message || '请求失败'));
    }
    return res;
  },
  error => {
    if (error.response?.status === 401) {
      if (isSilent(error.config)) return Promise.reject(error); // 后台轮询：先不惊动用户
      return confirmSessionLost().then(() => Promise.reject(error));
    }
    // 4xx 的后端提示（校验类）优先于 axios 的通用文案
    if (!isSilent(error.config)) {
      Message.error(error.response?.data?.message || error.message || '网络异常');
    }
    return Promise.reject(error);
  },
);

export default request;
